
export const focusDatepickerInput = {
  bind: (el: HTMLElement) => {
    el.addEventListener('click', () => (el.querySelector('.form-control') as HTMLElement).focus());
  },
};
